<template>
    <v-layout row wrap>
      <v-flex >
        <v-menu
          ref="menu"
          v-model="menu"
          :close-on-content-click="false"
          :nudge-right="40"
          :return-value.sync="date"
          lazy
          transition="scale-transition"
          offset-y
          full-width
          min-width="290px"
        >
          <template slot="activator" slot-scope="{ on }">
            <v-text-field
              :value="fieldValue"
              :label="label"
              :success-messages="successes"
              :error-messages="errors"
              :loading="loading"
              hint="YYYY/MM/DD"
              persistent-hint
              prepend-icon=""
              readonly
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker v-model="date" no-title scrollable>
            <v-spacer></v-spacer>
            <v-btn flat color="primary" @click="menu = false">Cancel</v-btn>
            <v-btn flat color="primary" @click="saveDate(date)">OK</v-btn>
          </v-date-picker>
        </v-menu>
      </v-flex>
    </v-layout>
</template>

<script>
export default {
  props: [
    'label', 'fieldName', 'object', 'mask', 'fieldType'
  ],
  computed: {
    fieldValue: {
      get: function() {
        return this.$store.state.employees.detailedEmployee[this.fieldName]
      },
    }
  },

  methods: {
    saveDate(newValue) {
      this.loading = true;
      this.$store.dispatch(
        'employees/update',
        { id: this.object.id, [this.fieldName]: newValue }
      )
      .then(res => {
        this.errors = []
        this.successes.push("Saved!")
        this.successClear = setInterval(() => {
          this.wipeSuccesses()
        }, 1500);

      })
      .catch(res => {
        this.errors.push("Couldn't be saved")
        // reset the value?
      })
      .finally(res => {
        this.loading = false;
        this.menu = false;
      })
    },
    wipeSuccesses: function() {
      this.successes = []
    }
  },

  data: function() {
    return {
      date: new Date().toISOString().substr(0, 10),
      menu: false,
      loading: false,
      errors: [],
      successes: [],
    }
  }
}
</script>
